import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { capitalizeFirstLetter, fetchData, reverseOrder } from '../functions';
import ItemRenderer from './ItemRenderer';

export default function ItemFilter() {
  const tagQuery = useQuery('tagData', () => fetchData('tag'));
  const statusQuery = useQuery('statusData', () => fetchData('status'));
  const treasureQuery = useQuery('treasureData', () => fetchData('treasure'));
  const [treasure, setTreasure] = useState(null);
  const [statuses, setStatuses] = useState(null);
  const [filteredTreasure, setFilteredTreasure] = useState([]);
  const [filteredTags, setFilteredTags] = useState(null);
  const [descriptionFilter, setDescriptionFilter] = useState('');
  const [tagFilter, setTagFilter] = useState('');
  const [selectedStatus, setSelectedStatus] = useState({id: 0, name: 'all'});

  useEffect(() => {
    if (statusQuery.data) {
      setStatuses(statusQuery.data);
      setSelectedStatus(statusQuery.data
        .find(status => status.name === 'listed')
      )
    }
  }, [statusQuery.data]);

  useEffect(() => {
    if (treasureQuery.data) {
      setTreasure(treasureQuery.data);
    }
  }, [treasureQuery.data]);

  useEffect(() => {
    if (treasure && tagQuery.data && statusQuery.data) {
      let treasureFilter = treasure
  
      if (selectedStatus.id) {
        treasureFilter = treasureFilter.filter(item => selectedStatus.id === 0 || item.statuses[0].status.id === selectedStatus.id)
      }
  
      if (tagFilter) {
        treasureFilter = treasureFilter.filter(treasure => {
          return treasure.tags.some(tag => tag.name?.toLowerCase().includes(tagFilter.toLowerCase()));
        });
      }

      if (descriptionFilter) {
        treasureFilter = treasureFilter.filter(treasure => {
          const currentDescription = treasure.description.toLowerCase();
          return currentDescription && currentDescription.includes(descriptionFilter.toLowerCase());
        });
      }

      const uniqueTagNames = Array.from(
        new Map(
          treasureFilter.flatMap(item => item.tags).map(tag => [tag.id, tag])
        ).values()
      );

      setFilteredTags(uniqueTagNames);
      setFilteredTreasure(reverseOrder(treasureFilter));
    }
  }, [treasure, statuses, descriptionFilter, tagFilter, tagQuery.data, statusQuery.data, selectedStatus]);

  const handleDescriptionChange = (event) => {
    setDescriptionFilter(event.target.value);
  };

  const handleTagChange = (event) => {
    setTagFilter(event.target.value);
  };

  const handleStatusChange = (statusObj) => {
    setSelectedStatus(prevSelected => {
      if (prevSelected.id !== statusObj.id) {
        return statusObj;
      } else {
        return prevSelected;
      }
    });
  };

  const resetStatusFilter = () => {
    setSelectedStatus({ id: 0, name: 'all' });
  };

  if (treasureQuery.isLoading) return 'Loading...';
  if (treasureQuery.error) return 'Error loading data';

  return (
    <div>
      <span>
        <label htmlFor="statusSelect">Status:</label>
        <select
          id="statusSelect"
          value={selectedStatus.id}
          onChange={(e) => {
            const selectedStatusId = Number(e.target.value);
            const selectedStatus = statuses.find(status => status.id === selectedStatusId) || {id: 0, name: 'all'};
            handleStatusChange(selectedStatus);
          }}
        >
          <option key={0} value={0}>any</option>
          {statuses && statuses.map((status) => (
            <option key={status.id} value={status.id}>
              {status.name}
            </option>
          ))}
        </select>
        <button onClick={resetStatusFilter}>Any</button>
      </span>
      <span> </span>
      <input 
        type="text" 
        placeholder="Filter by a Tag" 
        value={tagFilter} 
        onChange={handleTagChange}
        list="tagOptions"
      />
      <datalist id="tagOptions">
      {filteredTags && filteredTags.map((tag) => (
          <option key={tag.id} value={tag.name} />
        ))}
      </datalist>
      <button onClick={() => setTagFilter('')}>Clear</button>
      <span> </span>
      <input 
        type="text" 
        placeholder="Filter by Item Description" 
        value={descriptionFilter} 
        onChange={handleDescriptionChange}
        list="descriptionOptions"
      />
      <datalist id="descriptionOptions">
      {filteredTreasure && filteredTreasure.map((treasure) => (
          <option key={treasure.id} value={treasure.description} />
        ))}
      </datalist>
      <button onClick={() => setDescriptionFilter('')}>Clear</button>
      <h3>
        {capitalizeFirstLetter(selectedStatus.name)} Items
      </h3>
      <div>
        {(tagFilter || descriptionFilter) && " (Filtered)"}
      </div>
      {filteredTreasure.length > 0 ? (
        <ItemRenderer selectedStatus={selectedStatus} filteredTreasure={filteredTreasure}/>
      ) : (
        <div>No Items Found</div>
      )}
    </div>
  );
}
